// extracted by mini-css-extract-plugin
export default {"policyBck":"Policy_policyBck__+upvd"};